export default __webpack_public_path__ + "static/media/melltoo-img1.d4ad151b.png";